import { FC } from "react";
import { HgProduct } from "../../../types/taxonomy";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { OutlinedPaper } from "../../../components/OutlinedPaper";

interface ProductAttributesProps {
  productName: string;
  productAttributes?: HgProduct["attributes"];
}

export const ProductAttributes: FC<ProductAttributesProps> = (props) => {
  const navigate = useNavigate();

  return (
    <OutlinedPaper id="product-attributes-card" sx={{ p: 2 }}>
      <Stack gap="24px">
        <Typography variant="h4">
          {props.productName} Related Product Attributes
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "21px",
            maxWidth: "864px",
            padding: "0px 16px",
          }}
        >
          {props.productAttributes?.map(
            ({ name: productAttribute, id }, key) => {
              return (
                <button
                  key={key}
                  data-testid="catalog-product-attribute-btn"
                  style={{
                    display: "flex",
                    padding: "16px",
                    width: "420px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "1px",
                    boxSizing: "border-box",
                    border: "1px solid #EEEEEE",
                    background: "#ffffff",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(`/catalog/product/attribute/${id}`)}
                >
                  <Typography variant="h4" color="primary">
                    {productAttribute}
                  </Typography>
                </button>
              );
            }
          )}
        </Box>
      </Stack>
    </OutlinedPaper>
  );
};
